export const SUBSCRIPTIONTYPE_FREE = "Free";
export const SUBSCRIPTIONTYPE_STARTERCHAT = "Starter_Chat";
export const SUBSCRIPTIONTYPE_STARTERVOICE = "Starter_Voice";
export const SUBSCRIPTIONTYPE_ENTERPRISE = "Enterprise";
export const SUBSCRIPTIONTYPE_PROFESSIONAL = "Professional";
export const SUBSCRIPTIONTYPE_PAY_AS_YOU_GO = "Pay_As_You_Go";
export const SUBSCRIPTIONTYPE_ADDON_WHATSAPPBOT = "WhatsAppBot";
export const SUBSCRIPTIONTYPE_ADDON_INSTAGRAMBOT = "InstagramBot";
export const SUBSCRIPTIONTYPE_ADDON_EMAILBOT = "EmailBot";
export const SUBSCRIPTIONTYPE_ADDON_LINEBOT = "LineBot";
export const SUBSCRIPTIONTYPE_ADDON_FACEBOOKBOT = "FacebookBot";
export const SUBSCRIPTIONTYPE_ADDON_WEBBOT = "WebBot";


export const PREMIUM_SUBSCRIPTION_TYPES = [
    SUBSCRIPTIONTYPE_PROFESSIONAL,
    SUBSCRIPTIONTYPE_ENTERPRISE,
    SUBSCRIPTIONTYPE_STARTERCHAT,
    SUBSCRIPTIONTYPE_STARTERVOICE,
    SUBSCRIPTIONTYPE_PAY_AS_YOU_GO
  ];
